import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { ValueType } from 'rsuite/esm/Checkbox'
import { MultiFilter, type MultiFilterProps } from './MultiFilter'
import { PublicAdministrationMultiFilter } from './PublicAdministrationMultiFilter'
import type { IStartup } from 'domain/feature/hub/company/Ecosystem/contracts'
import type { PublicAdministrationFilterCounts } from 'domain/feature/hub/company/Ecosystem/publicAdministrationFilters'

export type { PublicAdministrationFilterCounts } from 'domain/feature/hub/company/Ecosystem/publicAdministrationFilters'

interface StartupFilterCounts {
  address_state: number
  activity: number
  business_model: number
  number_employees: number
  target: number
  investment_source: number
  development_stage: number
  has_raised_investment: number
}

type OnFilterChange = (type: string, values: ValueType[], checked: boolean) => void

export interface StartupFilterButtonProps {
  variant?: 'startup'
  startupData: IStartup[]
  filterData?: MultiFilterProps['filterData']
  onFilterChange: OnFilterChange
  filterCounts: StartupFilterCounts
  totalFilterCount: number
  selectedFilters?: Record<string, string[]>
  filterBarRef?: React.RefObject<HTMLDivElement | null>
}

export interface PublicAdministrationFilterButtonProps {
  variant: 'publicAdministration'
  onFilterChange: OnFilterChange
  filterCounts: PublicAdministrationFilterCounts
  totalFilterCount: number
  selectedFilters?: Record<string, string[]>
  filterBarRef?: React.RefObject<HTMLDivElement | null>
}

export type FilterButtonProps = StartupFilterButtonProps | PublicAdministrationFilterButtonProps

const isPublicAdministration = (p: FilterButtonProps): p is PublicAdministrationFilterButtonProps =>
  p.variant === 'publicAdministration'

export const FilterButton = (props: FilterButtonProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { onFilterChange, totalFilterCount, selectedFilters = {}, filterBarRef } = props

  const handleClick = (): void => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <span
        className="ecosystem-filtrar-btn"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#ECE2FC',
          borderRadius: '4px',
          padding: '4px 16px',
          fontSize: 14,
          fontWeight: 700,
          lineHeight: '24px',
          height: '32px',
          boxSizing: 'border-box',
          marginLeft: 0
        }}
        onClick={handleClick}
      >
        <FontAwesomeIcon
          style={{
            color: '#0066B3',
            fontSize: 18,
            marginRight: 8,
            alignSelf: 'center'
          }}
          icon={['fas', 'filter']}
        />
        <span style={{
          color: '#0066B3',
          fontWeight: 700,
          fontSize: 14,
          lineHeight: '24px',
          userSelect: 'none',
          fontFamily: 'sans-serif',
          whiteSpace: 'nowrap'
        }}>
          Filtrar{totalFilterCount > 0 ? ` (${totalFilterCount})` : ''}
        </span>
      </span>
      {isExpanded && isPublicAdministration(props) && (
        <PublicAdministrationMultiFilter
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          onFilterChange={onFilterChange}
          filterCounts={props.filterCounts}
          selectedFilters={selectedFilters}
          filterBarRef={filterBarRef}
        />
      )}
      {isExpanded && !isPublicAdministration(props) && (
        <MultiFilter
          startups={props.startupData}
          filterData={props.filterData}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          onFilterChange={onFilterChange}
          filterCounts={props.filterCounts}
          selectedFilters={selectedFilters}
          filterBarRef={filterBarRef}
        />
      )}
    </div>
  )
}
